import customFetch, { checkForUnauthorizedResponse } from "../../utils/axios";

export const getCountriesThunk = async (url, thunkAPI) => {
  try {
    const resp = await customFetch.get(url);
    return resp.data.data;
  } catch (error) {
    console.log(error.message);
    return checkForUnauthorizedResponse(error, thunkAPI);
  }
};
